"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.walletBalanceFactory = walletBalanceFactory;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _dateFns = require("date-fns");
const dateFormat = 'DD MMM YYYY';

/**
 * balance factory
 * @param balance
 * @param formatPrice
 * @returns {{}|{expiryDate: *, balanceAmount: string, expiryAmount: string}}
 */
function walletBalanceFactory(balance, formatPrice) {
  return {
    isBalanceAvailable: !(0, _isUndefined2.default)((0, _get2.default)(balance, 'data.availableBalance')),
    isExpiryAvailable: !(0, _isUndefined2.default)((0, _get2.default)(balance, 'data.nextRewardExpiry')) && !(0, _isNull2.default)((0, _get2.default)(balance, 'data.nextRewardExpiry.expiryDate')),
    // balanceAmount: `${_get(
    //   balance,
    //   'data.availableBalance.amountCurrency'
    // )} ${formatPrice(_get(balance, 'data.availableBalance.amount', 0))}`,
    balanceAmount: `${formatPrice((0, _get2.default)(balance, 'data.availableBalance.points', 0))}`,
    // expiryAmount: `${_get(
    //   balance,
    //   'data.nextRewardExpiry.amountCurrency'
    // )} ${formatPrice(_get(balance, 'data.nextRewardExpiry.amount', 0))}`,
    expiryAmount: `${formatPrice((0, _get2.default)(balance, 'data.nextRewardExpiry.points', 0))}`,
    expiryDate: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(balance, 'data.nextRewardExpiry.expiryDate')), dateFormat)
  };
}